export default __webpack_public_path__ + "static/media/footerWrapper.e4927695.svg";